import { render, staticRenderFns } from "./PoNumber.vue?vue&type=template&id=21e74cb8&"
import script from "./PoNumber.vue?vue&type=script&lang=js&"
export * from "./PoNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports